<template>
  <ListLayout
    title="Item Unit"
    :context="context"
    :tableData="itemUnitList"
    :tableHeader="tableHeaders"
    :total="totalItem"
    @getList="getItemUnitList"
  >
    <template #listAction>
      <v-btn @click="addItemUnit" color="primary" class="white--text" depressed>
        <v-icon>mdi-plus</v-icon>
        <span class="text-body-2">Add Item Unit</span>
      </v-btn>
    </template>
    <template #dialogs>
      <ItemUnitForm
        :editMode="isEditing"
        :itemUnitID="selectedItemUnitID"
        v-model="showItemUnitForm"
        @refreshList="getItemUnitList({ limit: 10, offset: 0 })"
      />
    </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import ItemUnitButton from "@/components/Button/ItemUnitButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import ItemUnitForm from "@/components/ModuleBasedComponents/ItemUnit/ItemUnitForm.vue";

export default {
  components: {
    ItemUnitButton,
    ListLayout,
    ItemUnitForm,
  },
  data() {
    return {
      sorting: {},
      itemUnitsPerPage: 10,
      pageNo: 1,
      totalItem: 0,
      filters: {},
      itemUnitList: [],
      headerSelected: [
        {
          headerName: "Name",
          field: "name",
          sortable: true,
        },
      ],

      isEditing: false,
      showItemUnitForm: false,
      selectedItemUnitID: null,
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 100,
          sortable: false,
          width: 100,
          cellRenderer: "ItemUnitButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    headersChanged(value) {
      this.headerSelected = value;
    },
    searchItemUnit() {
      this.pageNo = 1;
      this.getItemUnitList();
    },
    getItemUnitList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.filters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      this.$api.itemUnit
        .getItemUnitList(params)
        .then((res) => {
          this.itemUnitList = res.data;
          this.totalItem = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    addItemUnit() {
      this.selectedItemUnitID = null;
      this.isEditing = false;
      this.showItemUnitForm = true;
    },
    editItemUnit(id) {
      this.selectedItemUnitID = id;
      this.isEditing = true;
      this.showItemUnitForm = true;
    },
  },
};
</script>
